import { Text } from '@southfields-digital/mxmz-react-ui';
import classNames from 'classnames';

import { RugbyContestant } from 'src/types/matchControl/contestant';

import { ColorSwatch, ShortNameInput } from '../../components';
import styles from '../../MatchControl.module.scss';

type ScoreRowProps = {
  home: RugbyContestant;
  away: RugbyContestant;
  isCompact?: boolean;
  handleChangeColor: (
    contestant: RugbyContestant,
    color: 'primaryColor' | 'secondaryColor',
    value: string
  ) => void;
  handleChangeShortName: (contestant: RugbyContestant, name: string) => void;
};

// Score is calculated from scoring events so it is displayed read-only here
const ScoreRow = ({
  home,
  away,
  isCompact = false,
  handleChangeColor,
  handleChangeShortName,
}: ScoreRowProps) => (
  <div className={classNames('flex flex-col gap-6 w-full', isCompact && '!gap-3')}>
    <div className="flex gap-2 justify-around items-center">
      <div className="flex gap-2 flex-1 justify-start items-center">
        <div className="flex">
          <ColorSwatch
            color={home.primaryColor}
            onChange={(color) => handleChangeColor(home, 'primaryColor', color)}
            isCompact={isCompact}
          />
          <ColorSwatch
            color={home.secondaryColor}
            onChange={(color) => handleChangeColor(home, 'secondaryColor', color)}
            isCompact={isCompact}
          />
        </div>

        <Text
          className={classNames('!text-4xl text-center', isCompact ? 'w-7' : 'w-16')}
          as="h1"
          color="light"
        >
          {home.score.points}
        </Text>
      </div>

      <Text className="!text-4xl" as="h1" color="light">
        -
      </Text>

      <div className="flex gap-2 flex-1 justify-end items-center">
        <Text
          className={classNames('!text-4xl text-center', isCompact ? 'w-7' : 'w-16')}
          as="h1"
          color="light"
        >
          {away.score.points}
        </Text>

        <div className="flex">
          <ColorSwatch
            color={away.primaryColor}
            onChange={(color) => handleChangeColor(away, 'primaryColor', color)}
            isCompact={isCompact}
          />
          <ColorSwatch
            color={away.secondaryColor}
            onChange={(color) => handleChangeColor(away, 'secondaryColor', color)}
            isCompact={isCompact}
          />
        </div>
      </div>
    </div>

    <div className={styles.CurrentScoreWrapper}>
      <ShortNameInput
        value={home.shortName}
        onChange={(name) => handleChangeShortName(home, name)}
        isCompact={isCompact}
      />

      <ShortNameInput
        value={away.shortName}
        onChange={(name) => handleChangeShortName(away, name)}
        isCompact={isCompact}
      />
    </div>
  </div>
);

export default ScoreRow;
